import React from "react";
import { FaApple } from "react-icons/fa";

import {
  SiSamsung,
  SiHuawei,
  SiXiaomi,
  SiOppo,
  SiVivo,
  SiOneplus,
  SiGoogle,
} from "react-icons/si";

import "./SupportedBrands.css";

function SupportedBrands() {
  const brands = [
    { name: "Apple", icon: <FaApple /> },
    { name: "Samsung", icon: <SiSamsung /> },
    { name: "Huawei", icon: <SiHuawei /> },
    { name: "Xiaomi", icon: <SiXiaomi /> },
    { name: "Oppo", icon: <SiOppo /> },
    { name: "Vivo", icon: <SiVivo /> },
    { name: "OnePlus", icon: <SiOneplus /> },
    { name: "Google Pixel", icon: <SiGoogle /> },
  ];

  return (
    <section className="brands-section">
      <div className="container">
        <div className="section-heading text-center" data-aos="fade-up">
          <span className="section-badge">Supported Brands</span>

          <h2 className="section-title">Devices We Repair</h2>

          <p className="section-description">
            Our technicians are trained to repair all major smartphone brands
            and models using professional tools and quality parts.
          </p>
        </div>

        <div className="brands-grid">
          {brands.map((brand, index) => (
            <div
              className="brand-item"
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className="brand-icon">{brand.icon}</div>

              <span>{brand.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SupportedBrands;
